import type { ITableCell } from "@library-elements/table";
import { nanoid } from "@reduxjs/toolkit";

export const makeTableEmptyCell = (): ITableCell => ({
  id: nanoid(),
  colSpan: 1,
  rowSpan: 1,
  content: "",
});
